import { isEmpty, getDateString, getJsonDate } from "./JsonFunctions";
import { getTranslation } from "./GetTranslation";

declare var Cookies;

export const getMenuItems = (pages, activeComponent) => {
    let menuitems = [];
    
    for (var key in pages) {
        let menuItem = pages[key];
        let itemMenu = { 
            id: key,
            title: menuItem.title,
            className: menuItem.className,
            showHome: isEmpty(menuItem.showHome) ? true: menuItem.showHome,
            showNav: isEmpty(menuItem.showNav) ? true: menuItem.showNav,
            active: key === activeComponent,
            nr: menuItem.nr
        }
        menuitems.push(itemMenu);
    }
    
    return menuitems;
}

export const getFaseText = (id) => {
    switch(id) {
    case 0: return getTranslation("sns.general.extranet.kand_ontv");
    case 1: return getTranslation("sns.general.extranet.mail_brief_scr");
    case 2: return getTranslation("sns.general.extranet.tel_scr");
    case 3: return getTranslation("sns.general.extranet.1egespr");
    case 4: return getTranslation("sns.general.extranet.2egespr");
    case 5: return getTranslation("sns.general.extranet.voorst");
    case 6: return getTranslation("sns.general.extranet.testing");
    case 7: return getTranslation("sns.general.extranet.assessm");
    case 8: return getTranslation("sns.general.extranet.onderhandel");
    case 9: return getTranslation("sns.general.extranet.in_dienst");
    default: return "";
    }
}

export const getGender = (id) => {
    switch(id) {
    case 1 : return getTranslation("sns.webparts.personalia.geslacht.man");
    case 2 : return getTranslation("sns.webparts.personalia.geslacht.vrouw");
    default: return "";
    }
}

export const getMessageTypes = (creation = false) => {
    let messages = [
        {key: 1, value: getTranslation("sns.general.extranet.messagetype1")},
        {key: 2, value: getTranslation("sns.general.extranet.messagetype2")},
        {key: 3, value: getTranslation("sns.general.extranet.messagetype3")}
    ];

    if (creation) {
        messages.push({key: 0, value: getTranslation("sns.general.extranet.messagetype0")});
        return messages;
    }
    
    messages.push({key: 4, value: getTranslation("sns.general.extranet.messagetype4")});

    return messages;
}

export const getCreateMsgTitle = (candidateId, projectId) => {
    let title = (candidateId == null) ? 
                    (projectId == null ? 
                        getTranslation("sns.general.extranet.newmessage") // No candidate/project selected, we can choose
                        : getTranslation("sns.general.extranet.messagetype2")) // Project selected, use only messagetype 2
                    : getTranslation("sns.general.extranet.messagetype1"); // Candidate selected, use only messagetype 1

    return title;
}

export const isFilterDate = (filterValue, rowValue) => {
    var dateValues = filterValue.split("/");
    if (dateValues.length !== 3 || isNaN(dateValues[0]) || isNaN(dateValues[1]) || isNaN(dateValues[2])) {
        return true; // do not filter on wrong date
    }

    var filterDateString = (dateValues[0].length === 1 ? ("0" + dateValues[0]) : (dateValues[0])) + "/" +
        (dateValues[1].length === 1 ? ("0" + dateValues[0]) : (dateValues[1])) + "/" +
        (dateValues[2]);
    var rowDateString = getDateString(getJsonDate(rowValue));
    
    return rowDateString.indexOf(filterDateString) !== - 1;
}

export function signOff() {
    Cookies.remove("namezzz");
    Cookies.remove("userType");
}


// WEBPACK FOOTER //
// ./src/Utilities/SnsExtranetFunctions.js